import React from 'react';
import { useGetUserDetails } from '../../../api-refactored/user/useGetUserDetails';
import { Role } from '../../../models';
import SpecialConsiderationCoordinatorListing from '../CoordinatorListing';
import SpecialConsiderationListing from './SpecialConsiderationListing';

const SpecialConsiderationListingPage = () => {
  const { data: userDetails } = useGetUserDetails();

  const isCoordinator = userDetails?.data?.roles?.includes(Role.coordinator);

  return isCoordinator ? (
    <SpecialConsiderationCoordinatorListing />
  ) : (
    <SpecialConsiderationListing />
  );
};
export default SpecialConsiderationListingPage;
